import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const Page = ({ children }) => (
  <Box>
    {children}
  </Box>
);

Page.propTypes = { children: PropTypes.any };

Page.defaultProps = { children: null };

export default Page;
